// store/slices/oneClickBetSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type OneClickBetState = {
  enabled: boolean;
  selectedStake: string | null;
};

const initialState: OneClickBetState = {
  enabled: false,
  selectedStake: null,
};

const oneClickBetSlice = createSlice({
  name: 'oneClickBet',
  initialState,
  reducers: {
    setOneClickEnabled: (state, action: PayloadAction<boolean>) => {
      state.enabled = action.payload;

      if (!action.payload) {
        state.selectedStake = null;
      }
    },

    setSelectedOneClickStake: (state, action: PayloadAction<string | null>) => {
      state.selectedStake = action.payload;
    },

    resetOneClickBet: (state) => {
      state.enabled = false;
      state.selectedStake = null;
    },
  },
});

export const { setOneClickEnabled, setSelectedOneClickStake, resetOneClickBet } =
  oneClickBetSlice.actions;

export default oneClickBetSlice.reducer;
